export class ChunkLoadUtils {

  private static readonly attemptsKey = 'chunkReloadAttempts';
  // One reload is what a stale bundle needs; the second covers a deploy that lands during the
  // recovery itself. A chunk still missing after that is not staleness, and reloading again only
  // costs the user another round trip.
  private static readonly maxReloads = 2;

  static isChunkLoadError(error: any): boolean {
    const message = error?.message || '';
    return error?.name === 'ChunkLoadError'
      || message.indexOf('Loading chunk') >= 0
      || message.indexOf('Failed to fetch dynamically imported module') >= 0
      || message.indexOf('error loading dynamically imported module') >= 0;
  }

  // Reloads to pick up the new build after a deploy, up to maxReloads for the life of the tab.
  // Counted, not timed: a cooldown window re-arms itself, so a chunk that keeps failing more
  // slowly than the window reloads the page forever. Pass targetUrl (a base-href-resolved URL) to
  // land on the route the user was navigating to; omit it to reload the current page.
  //
  // Returns false without reloading when the count cannot be kept or raised. The count is the
  // whole bound, and reloading without one is the failure this guards against -- the caller shows
  // its retry instead, which is bounded by the user.
  static reloadForNewBuild(targetUrl?: string): boolean {
    const attempts = ChunkLoadUtils.readAttempts();
    if (attempts === null || attempts >= ChunkLoadUtils.maxReloads) {
      return false;
    }
    if (!ChunkLoadUtils.writeAttempts(attempts + 1)) {
      return false;
    }
    if (targetUrl) {
      window.location.href = targetUrl;
    } else {
      window.location.reload();
    }
    return true;
  }

  // null when session storage cannot be read, which is not the same as no attempts yet: a browser
  // that denies storage would otherwise read 0 on every failure and reload without end.
  private static readAttempts(): number | null {
    try {
      return Number(sessionStorage.getItem(ChunkLoadUtils.attemptsKey)) || 0;
    } catch {
      return null;
    }
  }

  private static writeAttempts(attempts: number): boolean {
    try {
      sessionStorage.setItem(ChunkLoadUtils.attemptsKey, String(attempts));
      return true;
    } catch {
      return false;
    }
  }

}
